import type { RefObject } from 'react';
import styled from 'styled-components';
import { Text } from '@visx/text';
import type { TextProps } from '@/thirdparty/@vx/text';

export interface TitleProps extends TextProps {
  color: string;
  dx: number;
  dy: number;
  fontOverride?: TemplateStringsArray;
  innerRef: RefObject<SVGSVGElement>;
  width: number;
  y: number;
}

const TitleTextComponent = ({
  children,
  fontOverride,
  ...rest
}: TitleProps) => <Text {...(rest as any)}>{children}</Text>;

export const Title = styled(TitleTextComponent)`
  tspan {
    ${({ theme, fontOverride }) =>
      fontOverride || theme.typography.xSmallStrong}
    text-transform: capitalize;
    fill: ${({ color }) => color};
  }
`;

export interface ValueProps extends TextProps {
  color: string;
  dx: number;
  dy: number;
  fontOverride?: TemplateStringsArray;
  innerRef: RefObject<SVGSVGElement>;
  negOrNull: boolean;
  width: number;
  y: number;
}

const ValueTextComponent = ({
  children,
  negOrNull,
  fontOverride,
  ...rest
}: ValueProps) => <Text {...(rest as any)}>{children}</Text>;

export const Value = styled(ValueTextComponent)`
  tspan {
    ${({ theme, fontOverride }) => fontOverride || theme.typography.largeStrong}
    fill: ${({ theme, negOrNull, color }) =>
      negOrNull ? theme.color.bad : color ? color : theme.color.white};
  }
`;
